var substitutePattern = /\{(.*?)\}/g;
export var trim = function trim(string) {
  return string && typeof string.trim === "function" ? string.trim() : string;
};
export var abbreviate = function abbreviate(string, length) {
  return string.substring(0, length);
};
export var substitute = function substitute() {
  var template = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return template.replace(substitutePattern, function (_, key) {
    return data[key] || "";
  });
};
export var toKebabCase = function toKebabCase(string) {
  return string.replace(/[A-Z]/g, function (match, offset) {
    return offset > 0 ? "-".concat(match.toLowerCase()) : match.toLowerCase();
  });
};